import api from '../../api/axios';
import { showError } from '../../Components/reuse/Toast';

export const PACKAGES_LIST_REQUEST = 'PACKAGES_LIST_REQUEST';
export const PACKAGES_LIST_SUCCESS = 'PACKAGES_LIST_SUCCESS';
export const PACKAGES_LIST_FAILURE = 'PACKAGES_LIST_FAILURE';

export const getAllPackages = ({
  status,
  company,
  email,
  packageName,
  packageCycle,
  startDate,
  endDate,
  page = 1,
  limit = 15,
} = {}) => async (dispatch) => {
  dispatch({ type: PACKAGES_LIST_REQUEST });
  try {
    const body = { status, company, email, packageName, packageCycle, startDate, endDate };
    const response = await api.post('packages/getAllPackages', body, { params: { page, limit } });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: PACKAGES_LIST_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch packages';
    dispatch({ type: PACKAGES_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch packages';
    dispatch({ type: PACKAGES_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};


